import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['dialog', 'content', 'status']

  connect() {
    this.sequence = (this.sequence || 0) + 1
  }

  disconnect() {
    this.cancelRequest()
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
  }

  open(event) {
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    this.opener = event.currentTarget
    this.load(event.currentTarget.href)
  }

  inspect(event) {
    if (!this.hasDialogTarget || !this.dialogTarget.open) this.opener = event.detail.opener
    this.load(event.detail.url)
  }

  navigate(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    if (!this.hasDialogTarget || !this.dialogTarget.open) this.opener = event.currentTarget
    this.load(event.currentTarget.href)
  }

  changeSelection(event) {
    this.loadForm(event.target.form, event.target.id)
  }

  submitSelection(event) {
    event.preventDefault()
    this.loadForm(event.target)
  }

  loadForm(form, focusId) {
    const url = new URL(form.action, window.location.href)
    url.search = new URLSearchParams(new FormData(form)).toString()
    this.load(url.toString(), focusId)
  }

  async load(url, focusId) {
    if (!this.hasDialogTarget) {
      window.location = url
      return
    }
    this.cancelRequest()
    const sequence = this.sequence
    this.request = new AbortController()
    if (!this.dialogTarget.open) {
      this.dialogTarget.showModal()
      this.element.dispatchEvent(new CustomEvent('matrix-inspector:opened', { bubbles: true }))
    }
    // Release the previous scene before mounting the selected truck or fleet
    // page, including when the user changes selections rapidly.
    this.contentTarget.replaceChildren()
    this.contentTarget.setAttribute('aria-busy', 'true')
    this.statusTarget.textContent = 'Loading selected load…'
    this.statusTarget.hidden = false
    try {
      const response = await fetch(url, {
        credentials: 'same-origin', signal: this.request.signal,
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      })
      if (response.redirected || !response.ok) throw new Error('Could not load this selection. Close the preview and try again.')
      const html = await response.text()
      if (sequence !== this.sequence || !this.dialogTarget.open) return
      this.contentTarget.innerHTML = html
      this.dialogTarget.classList.toggle('is-fleet-preview', Boolean(this.contentTarget.querySelector('[data-controller="fleet-preview"]')))
      this.statusTarget.hidden = true
      const focusTarget = focusId ? this.contentTarget.querySelector(`#${focusId}`) : this.contentTarget.querySelector('[data-inspection-heading]')
      focusTarget?.focus({ preventScroll: true })
    } catch (error) {
      if (sequence !== this.sequence || error.name === 'AbortError') return
      this.statusTarget.textContent = error.message || 'Could not load this selection. Try again.'
    } finally {
      if (sequence === this.sequence) this.contentTarget.removeAttribute('aria-busy')
    }
  }

  close() {
    this.dialogTarget.close()
  }

  closed() {
    this.cancelRequest()
    this.contentTarget.replaceChildren()
    this.element.dispatchEvent(new CustomEvent('matrix-inspector:closed', { bubbles: true }))
    this.opener?.focus({ preventScroll: true })
  }

  cancelRequest() {
    this.sequence += 1
    this.request?.abort()
    this.request = null
  }
}
